import React from "react";

interface RadioProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

const Radio: React.FC<RadioProps> = ({ checked, onChange }) => {
  return (
    <button className="w-4 min-w-4 h-4 rounded-full border border-gray-300 flex items-center justify-center">
      <span
        className={`w-3 h-3 rounded-full ${
          checked ? "bg-[var(--app-primary)]" : "bg-white"
        }`}
      ></span>
    </button>
  );
};

export default Radio;
